import google from './google.svg';
import facebook from './facebook.svg';

const icons = {facebook, google};
export default icons;
